import { Link } from 'react-router-dom';

export default function WhyChooseUs() {
  const benefits = [
    {
      icon: 'ri-shield-check-line',
      title: '$250 Flat Doc Fee',
      description: '$250 flat doc fee — that\'s the only dealer fee. No hidden charges.',
    },
    {
      icon: 'ri-truck-line',
      title: 'Free Delivery',
      description: 'We deliver to most areas in Oregon and Washington at no extra cost.',
    },
    {
      icon: 'ri-heart-line',
      title: 'Give Back Locally',
      description: 'Every purchase helps rescue dogs in the Pacific Northwest.',
    },
    {
      icon: 'ri-time-line',
      title: 'No-Pressure Sales',
      description: 'Take your time, ask questions, and make the right decision for you.',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="font-oswald text-4xl font-bold text-[#1A2332] mb-4">
            Why Choose Rockhound Auto Sales
          </h2>
          <p className="text-lg text-[#374151] max-w-2xl mx-auto">
            We're not your typical dealership. We're here to change the way you buy used cars.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-[#F7F5F0] border border-[#E8E2D6] rounded-full flex items-center justify-center mx-auto mb-4" aria-hidden="true">
                <i className={`${benefit.icon} text-3xl text-[#E8B84B]`}></i>
              </div>
              <h3 className="font-oswald text-xl font-bold text-[#1A2332] mb-2">
                {benefit.title}
              </h3>
              <p className="text-[#374151]">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export { WhyChooseUs };
